export default {
  setHadith(state, data) {
    state.hadith = data;
  },

  setAllNews(state, data) {
    state.allNews = data;
  },

  setLastNews(state, data) {
    state.lastNews = data;
  },

  setChooseNews(state, data) {
    state.chooseNews = data;
  },

  setElectronicServices(state, data) {
    state.electronicServices = data;
  },

  setNewsLetters(state, data) {
    state.newsLetters = data;
  },

  setMoreLikeNews(state, data) {
    state.moreLikeNews = data;
  },

  setNewsGroups(state, data) {
    state.newsGroups = data;
  },

  setGroups(state, data) {
    state.groups = data;
  },

  setMoreViewNews(state, data) {
    state.moreViewNews = data;
  },

  setNewestNews(state, data) {
    state.newestNews = data;
  },

  setOneNews(state, data) {
    state.oneNews = data;
  },

  setContactUs(state, data) {
    state.contactUs = data;
  },

  setIntroductions(state, data) {
    state.introductions = data;
  },

  setOneIntroduction(state, data) {
    state.oneIntroduction = data;
  },

  setLastProvinceNews(state, data) {
    state.lastProvinceNews = data;
  },

  setLinks(state, data) {
    state.links = data;
  },

  setSlider(state, data) {
    state.slider = data;
  },

  setBanner(state, data) {
    state.banner = data;
  },

  setZones(state, data) {
    state.zones = data;
  },

  setLastSubjects(state, data) {
    state.lastSubjects = data;
  },
  setChooseSubjects(state, data) {
    state.chooseSubjects = data;
  },
  setMoreLikeSubjects(state, data) {
    state.moreLikeSubjects = data;
  },
  setMoreviewSubjects(state, data) {
    state.moreviewSubjects = data;
  },
  setNewestSubjects(state, data) {
    state.newestSubjects = data;
  },
  setAllSubjects(state, data) {
    state.allSubjects = data;
  },
  setGetOneSubjects(state, data) {
    state.getOneSubjects = data;
  },
};
